<template>
    <div class="main">
        <c-panel :title="titulo" :titleIcon="icone">
            <mapa></mapa>
        </c-panel>
    </div>
</template>
<script>
import mapa from "./mapa"
export default {
    components: { mapa },
    data () { return { titulo: '', icone: '' } },
    created () {
        this.titulo = this.$route.meta && this.$route.meta.title ? this.$route.meta.title : ''
        this.icone = 'fas fa-chart-line'
    }
}
</script>
